module.exports = __webpack_public_path__ + "static/media/jwalker.d3d6d522.svg";